import { weeksToDays } from 'date-fns';

import type { LeadTimeStrategy } from './types';

export const CSCLeadTimeStrategy: LeadTimeStrategy = {
  calculateDays: () => {
    return weeksToDays(1);
  },
};
